import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ITileInstance } from '../../dashboards/interfaces/tiles/definition-helpers/tile-definition.interface';
import { TILE_TYPES } from '../constants/tile-types.constant';
import { DynamicTileWidget } from '../components/widgets/dynamic.component';
import { InvalidTileComponent } from '../../dashboards/components/tiles/meta/invalid-tile/invalid-tile.component';
import { ITileType } from '../interfaces/tile-type.interface';

export interface ITileRequest {
  tileInstance: ITileInstance;
  tileType: ITileType;
}

@Injectable({ providedIn: 'root' })
export class TileCreatorService {
  readonly onChange = new Subject<void>();
  readonly onCreateRequest = new Subject<ITileRequest>();
  readonly onUpdateRequest = new Subject<ITileRequest>();

  private getTileType(tileInstance: ITileInstance): ITileType {
    const tileType = TILE_TYPES.find(({ key }) => tileInstance?.tileType === key);
    if (tileType) {
      return tileType;
    }

    return {
      key: tileInstance?.tileType ?? 'unknown',
      name: tileInstance?.tileType ?? 'Unknown tile',
      setupWizard: DynamicTileWidget,
      component: InvalidTileComponent,
    };
  }

  requestTileCreate(tileTypeKey: string, tileInstance: ITileInstance): void {
    tileInstance.tileType = tileTypeKey;
    tileInstance.canView = true;
    this.onCreateRequest.next({
      tileInstance: tileInstance,
      tileType: TILE_TYPES.find(({ key }) => tileTypeKey === key),
    });
  }

  requestTileUpdate(tileInstance: ITileInstance) {
    this.onUpdateRequest.next({
      tileInstance: tileInstance,
      tileType: this.getTileType(tileInstance),
    });
  }
}
